const LINK_BASE =
    'component-content-toc__link relative block border-b border-white/10 py-7 pl-4 pr-5 text-[16px] leading-[30px] no-underline transition-colors hover:text-bluepira lg:py-3';
const LINK_INACTIVE = 'text-white';
const LINK_ACTIVE =
    "text-bluepira after:absolute after:right-0 after:top-1/2 after:h-8 after:w-[3px] after:-translate-y-1/2 after:rounded-full after:bg-bluepira after:content-['']";

export default class ContentToc {
    constructor() {
        this.toc = document.querySelector('.component-content-toc');
        this.inner = this.toc?.querySelector('.component-content-toc__inner');
        this.list = this.toc?.querySelector('.component-content-toc__list');
        this.section = this.toc?.closest('.block-contents');
        this.body = this.section?.querySelector('.block-contents-body');
        this.clickedId = null;

        if (!this.toc || !this.inner || !this.list || !this.section || !this.body) {
            return;
        }

        this.onScroll = this.onScroll.bind(this);
        this.init();
    }

    slugify(text, index) {
        const slug = text
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .trim()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');

        return slug || `secao-${index + 1}`;
    }

    setActive(id) {
        this.list.querySelectorAll('.component-content-toc__link').forEach((link) => {
            const active = link.getAttribute('href') === `#${id}`;
            link.className = `${LINK_BASE} ${active ? LINK_ACTIVE : LINK_INACTIVE}`;
        });
    }

    setInnerStyle(styles = {}) {
        Object.assign(this.inner.style, {
            position: '',
            top: '',
            left: '',
            width: '',
            zIndex: '',
            ...styles,
        });
    }

    onScroll() {
        if (window.innerWidth < 1024) {
            this.setInnerStyle();
            return;
        }

        const header = document.querySelector('.menu-fixo');
        const headerHeight = header ? header.offsetHeight : 128;
        const offsetTop = headerHeight + 40;
        const innerHeight = this.inner.offsetHeight;
        const sectionRect = this.section.getBoundingClientRect();
        const asideRect = this.toc.getBoundingClientRect();
        const width = `${this.toc.offsetWidth}px`;

        if (sectionRect.top > headerHeight) {
            this.setInnerStyle();
            return;
        }

        if (sectionRect.bottom - innerHeight <= offsetTop) {
            this.setInnerStyle({
                position: 'absolute',
                top: `${this.section.offsetHeight - innerHeight}px`,
                left: `${asideRect.left - sectionRect.left}px`,
                width,
                zIndex: '20',
            });
            return;
        }

        this.setInnerStyle({
            position: 'fixed',
            top: `${offsetTop}px`,
            left: `${asideRect.left}px`,
            width,
            zIndex: '20',
        });
    }

    init() {
        const headings = [...this.body.querySelectorAll('h1, h2')].filter((heading) => heading.textContent.trim());

        if (!headings.length) {
            this.toc.classList.add('!hidden');
            return;
        }

        const usedIds = {};

        headings.forEach((heading, index) => {
            let id = heading.id || this.slugify(heading.textContent, index);
            usedIds[id] = (usedIds[id] || 0) + 1;
            if (usedIds[id] > 1) {
                id = `${id}-${usedIds[id]}`;
            }
            heading.id = id;

            const link = document.createElement('a');
            link.href = `#${id}`;
            link.className = `${LINK_BASE} ${index === 0 ? LINK_ACTIVE : LINK_INACTIVE}`;
            link.textContent = heading.textContent.trim();
            link.addEventListener('click', (event) => {
                event.preventDefault();
                this.clickedId = id;
                this.setActive(id);
                heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
                history.replaceState(null, '', `#${id}`);
                clearTimeout(this.clickTimer);
                this.clickTimer = setTimeout(() => {
                    this.clickedId = null;
                }, 800);
            });

            const item = document.createElement('li');
            item.appendChild(link);
            this.list.appendChild(item);
        });

        const observer = new IntersectionObserver(
            (entries) => {
                if (this.clickedId) {
                    return;
                }

                const visible = entries
                    .filter((entry) => entry.isIntersecting)
                    .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

                if (visible.length) {
                    this.setActive(visible[0].target.id);
                }
            },
            { rootMargin: '-20% 0px -65% 0px' }
        );

        headings.forEach((heading) => observer.observe(heading));
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        this.onScroll();
    }
}

if (document.querySelector('.component-content-toc')) {
    new ContentToc();
}
